
import Vue from 'vue';
import ServerAddress from "@/views/login/partials/ServerAddress.vue";
import msDataProvider from "@/services/msDataProvider";
import errorService from "@/services/errorService";
import {mdiArrowLeft} from "@mdi/js";
import XCardBasedForm from "@/components/XCardBasedForm.vue";
export default Vue.extend({
  name: "FirstTimeLogin",
  components: {
    ServerAddress,
    XCardBasedForm,
  },
  data() {
    return {
      alertShown: false,
      showDetailError: false,
      errorService,
      mdiArrowLeft,
      error: "",
      sheet: false,
      availableMfas: {},
      binding: {},
      showOptionMethod: false,
      backendServerNameShown: false,
      backendServerNameSaving: false,
      backendServerName: "",
      triggerFn: () => {},
      labelBtn: this.$t("APP.CONTINUE"),
      type: 'text-field',
      disabled: false,
    }
  },
  methods: {
    async submit(callback) {
      this.labelBtn = this.$t("APP.CHECKING");
      const result = await this.triggerFn();
      if (result) {
        this.$router.push({path: '/login/select_server_name', query: { firstTime: true }});
        return;
      }
      this.labelBtn = this.$t("APP.CONTINUE");
      callback(false, false);
    },
  },
  async created() {
    await msDataProvider.bindDataMany(
        [
          "updateAvailableVersionsInfo",
          "updateApplied",
          "backendServerNameCurrentValue",
          "backendServerNameDefaultValue",
          "setting",
        ],
        this.binding,
        this,
        null,
        this
    );
  }
})
